import React, {useState, useEffect, useRef} from 'react';
import {dropdownNoFill} from '../assets/images/images';

function PageLimit({onLimitChange, className, limit}) {
  const [drop, setDrop] = useState(false);
  const [, setLimit] = useState(10);
  const ref = useRef();

  const changeLimit = num => {
    setLimit(num);
    onLimitChange(num);
  };

  useEffect(() => {
    const handleClickOutside = e => {
      if (!ref?.current?.contains(e.target)) {
        setDrop(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
  }, [ref]);

  return (
    <div
      className={`${className} page-limit flex items-center text-[#5C688E] text-sm`}
    >
      <span>Rows per page:</span>
      <button
        onClick={() => setDrop(!drop)}
        ref={ref}
        className="ml-1 flex items-center gap-[2px]"
      >
        {limit} <img src={dropdownNoFill} alt="" width={16} height={16} />
        {drop && (
          <div className="dropdown">
            <span onClick={() => changeLimit(10)}>10</span>
            <span onClick={() => changeLimit(20)}>20</span>
            <span onClick={() => changeLimit(50)}>50</span>
            <span onClick={() => changeLimit(100)}>100</span>
          </div>
        )}
      </button>
    </div>
  );
}

export default PageLimit;
